import { createNamespacedHelpers } from 'vuex';

export const eventsModuleName = '$_events';
export const parentModule = createNamespacedHelpers('$_students');
export const eventsModule = createNamespacedHelpers(eventsModuleName);
